import { type LucideIcon } from "lucide-react";

interface FloatingIcon {
  icon: LucideIcon;
  color: "mint" | "orange" | "primary";
}

interface ProductHeroVisualProps {
  imageSrc: string;
  imageAlt: string;
  floatingIcons: [FloatingIcon, FloatingIcon, FloatingIcon, FloatingIcon];
}

const colorMap = {
  mint: {
    bg: "bg-chathero-mint/20",
    border: "border-chathero-mint/30",
    text: "text-chathero-mint",
  },
  orange: {
    bg: "bg-chathero-orange/20",
    border: "border-chathero-orange/30",
    text: "text-chathero-orange",
  },
  primary: {
    bg: "bg-primary/20",
    border: "border-primary/30",
    text: "text-primary",
  },
};

const positions = [
  { className: "absolute -top-4 -right-4 z-20", duration: "3s", delay: "0s" },
  { className: "absolute bottom-20 -right-8 z-20", duration: "3.5s", delay: "0.5s" },
  { className: "absolute top-1/2 -left-8 z-20", duration: "4s", delay: "1s" },
  { className: "absolute bottom-8 -left-4 z-20", duration: "3.2s", delay: "1.5s" },
];

const ProductHeroVisual = ({ imageSrc, imageAlt, floatingIcons }: ProductHeroVisualProps) => {
  return (
    <div className="relative w-full max-w-lg mx-auto animate-scale-in" style={{ animationDelay: "0.3s" }}>
      {/* Decorative mint circle background */}
      <div className="absolute -top-8 -right-8 w-[450px] h-[450px] rounded-full bg-gradient-to-br from-chathero-mint to-chathero-mint/40 blur-sm" />

      {/* Person image */}
      <div className="relative z-10">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-auto rounded-3xl shadow-2xl"
          width="512"
          height="600"
          loading="eager"
          fetchPriority="high"
        />
      </div>

      {/* Floating channel icons */}
      {floatingIcons.map((item, i) => {
        const Icon = item.icon;
        const colors = colorMap[item.color];
        const pos = positions[i];
        return (
          <div
            key={i}
            className={`${pos.className} w-14 h-14 rounded-2xl bg-background shadow-xl flex items-center justify-center animate-bounce`}
            style={{ animationDuration: pos.duration, animationDelay: pos.delay }}
          >
            <Icon className={`w-7 h-7 ${colors.text}`} />
          </div>
        );
      })}
    </div>
  );
};

export default ProductHeroVisual;
